// extracted by mini-css-extract-plugin
module.exports = {"left_img":"leftImageRightNews-m__left_img__2vxV3","base":"leftImageRightNews-m__base__c1lVS"};